import { useState, useEffect } from 'react';
import { productService } from '@services/api';

export const useProduct = (id) => {
  const [product, setProduct] = useState(null);
  const [relatedProducts, setRelatedProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        setLoading(true);
        const data = await productService.getById(id);
        setProduct(data.product);
        setRelatedProducts(data.relatedProducts || []);
        setError(null);
      } catch (err) {
        setError(err.message);
        // Mock data for demo
        setProduct({
          id,
          title: 'Sample Product',
          description: 'Product description',
          price: 199.99,
          stockStatus: 'in-stock',
          image: '/images/1.jpg',
          images: ['/images/1.jpg', '/images/2.jpg'],
        });
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchProduct();
    }
  }, [id]);

  return { product, relatedProducts, loading, error };
};

